import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationReviewComponent } from './application-review/application-review.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AroTileComponent } from './aro-tile/aro-tile.component';
import { ApplicationReviewSmartComponent } from './application-review-smart/application-review-smart.component';
import { ToolitipListModule } from 'app/pipes/tooltip-list/tooltip-list-pipe.module';
import { CollapsibleContainerModule } from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';



@NgModule({
  declarations: [
    ApplicationReviewComponent,
    AroTileComponent,
    ApplicationReviewSmartComponent
  ],
  imports: [
    CollapsibleContainerModule,
    CommonModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    ToolitipListModule
  ],
  exports: [
    ApplicationReviewSmartComponent,
    ApplicationReviewComponent,
    AroTileComponent
  ]
})
export class ApplicationReviewModule { }
